export { FloatingManager } from "./FloatingManager";
export { Tooltip } from "./Tooltip";
export { UserCard } from "./UserCard";

// Konkord: leaf module, so menus outside ui/ can use these without pulling
// the floating layer (and its imports) in: that made a circular import
export { keepFloatingOpen, swallowNextClick } from "./clicks";

/**
 * Trigger a global pointerdown running the floating close logic
 */
export function dismissFloatingElements() {
  document.dispatchEvent(new Event("pointerdown"));
}
